import React, { useState } from "react";
import { ValidatorForm } from "react-form-validator-core";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../layout/Header";
import { backIcon2 } from "../../../Image/Index";
import TextValidator from "../../partial/TextValidator";
import SelectValidator from "../../partial/SelectValidator";
import TextAreaValidator from "../../partial/TextAreaValidator";
import { selectValueGetter } from "../../../utils/helper";
import { createCustomerSchema } from "../../../services/services";
import { decrypt } from "../../../utils/encodingdecoding";
import { Button, CloseButton, Modal } from "react-bootstrap";

const CustomerViewMOdal = (props) => {
  const [state, setState] = useState({});
  const [fieldName, setFieldName] = useState("");
  const [fielddisplayname, setFielddisplayname] = useState("");
  const [fielddatatype, setFielddatatype] = useState("");
  const [description, setDescription] = useState("");
  const [type, setType] = useState("");
  const [loader, setLoader] = useState(false);
  const [toggles, setToggles] = useState({
    isRuleSupported: false,
    isIdent: false,
    isRequired: false,
    displayingrid: false,
    isPublic: false,
    isEncrypted: false,
    isPhone: false,
    isCardTemplate: false,
    isCustomerField: false,
    isTransactionDate: false,
    isTransactionMethodKey: false,
    isTransactionMethodValue: false,
    isTransactionChannel: false,
    isTransactionAmount: false,
    isSignUp: false,
    isSearchable: false,
    IsMerchant: false,
    isSso: false,
    isTransactionTime: false,
    isSourceName: false,
    isSourceType: false,
    isBankTransId: false,
    isFormView: false,
    isRedeemFormField: false,
  });
  const navigate = useNavigate();
  const [options] = useState([
    { value: "", label: "Select" },
    { value: "Array", label: "Array", type: "array" },
    { value: "Boolean", label: "Boolean", type: "boolean" },
    { value: "Enumuration", label: "Enumuration", type: "enumuration" },
    { value: "Object", label: "Object", type: "object" },
    { value: "Number", label: "Number", type: "number" },
    { value: "String", label: "String", type: "string" },
  ]);
  const handleFieldNameChange = (e) => {
    setFieldName(e.target.value);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "fielddisplayname") {
      setFielddisplayname(value);
    } else if (name === "description") {
      setDescription(value);
    }
  };
  const handleSelectChange = (selectedOption) => {
    setFielddatatype(selectedOption.value);
    setType(selectedOption.type);
  };
  const handleToggleChange = (toggleName) => {
    setToggles(prevState => ({
      ...prevState,
      [toggleName]: !prevState[toggleName],
    }));
  };
  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const chunkArray = (array, chunkSize) => {
    const result = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }
    return result;
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      [fieldName]: {
        fielddatatype: fielddatatype,
        StringTypeValidation: [],
        fielddisplayname: fielddisplayname,
        type: type,
        description: description,
        ...toggles,
      }
    };
    try {
      setLoader(true);
      const token = JSON.parse(localStorage.getItem("token_gen"));
      let id = decrypt(localStorage.getItem("Id"));
      const response = await createCustomerSchema(token?.access_token, formData, id,);
    } catch (error) {
    } finally {
      setLoader(false);
    }
    setFieldName("");
    setFielddisplayname("");
    setFielddatatype("");
    setDescription("");
    setType("");
    setToggles({
      isRuleSupported: false,
      isIdent: false,
      isRequired: false,
      displayingrid: false,
      isPublic: false,
      isEncrypted: false,
      isPhone: false,
      isCardTemplate: false,
      isCustomerField: false,
      isTransactionDate: false,
      isTransactionMethodKey: false,
      isTransactionMethodValue: false,
      isTransactionChannel: false,
      isTransactionAmount: false,
      isSignUp: false,
      isSearchable: false,
      IsMerchant: false,
      isSso: false,
      isTransactionTime: false,
      isSourceName: false,
      isSourceType: false,
      isBankTransId: false,
      isFormView: false,
      isRedeemFormField: false,
    });
  };
  return (
    <>
      <Modal show={props.show} onHide={props.close} size="lg" centered>
        <Modal.Header>
          <Modal.Title style={{ fontSize: "16px", fontWeight: 600 }}>Customer Schema</Modal.Title>
          <CloseButton onClick={props.close} />
        </Modal.Header>
        <Modal.Body className="dashboard__transactionsModal" style={{ position: "relative", minHeight: "85px" }}>
          <div className="dashboard__profileSettingsBox">
            <ValidatorForm className="customForm customForm_2" onSubmit={onSubmit}>
              <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                  <div className="form-group">
                    <label>
                      Field Name<span style={{ color: "red" }}>*</span>
                    </label>
                    <TextValidator
                      maxLength="50"
                      className="form-control"
                      placeholder="Enter Field Name"
                      value={fieldName}
                      name="fieldName"
                      onChange={handleFieldNameChange}
                      validators={["required", "matchRegexp:^[a-zA-Z0-9@$ ]*$"]}
                      errorMessages={[
                        "Please enter field Name",
                        "Only letters, numbers, @, and $ are allowed.",
                      ]}
                    />
                  </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                  <div className="form-group">
                    <label>
                      Field Display Name<span style={{ color: "red" }}>*</span>
                    </label>
                    <TextValidator
                      maxLength="50"
                      className="form-control"
                      name="fielddisplayname"
                      placeholder="Enter Field Display Name"
                      value={fielddisplayname}
                      onChange={handleChange}
                      validators={["required", "matchRegexp:^[a-zA-Z0-9@$ ]*$"]}
                      errorMessages={[
                        "Please enter field display name",
                        "Only letters, numbers, @, and $ are allowed.",
                      ]}
                    />
                  </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                  <div className="form-group">
                    <label>
                      Field Data Type<span style={{ color: "red" }}>*</span>
                    </label>
                    <SelectValidator
                      placeholder="Select Type"
                      className="custom-ReactSelect bordered"
                      name="fielddatatype"
                      options={options}
                      value={selectValueGetter(options, fielddatatype) || ""}
                      onChange={handleSelectChange}
                      validators={["required"]}
                      errorMessages={["Please enter field data type"]}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label>Description</label>
                    <TextAreaValidator
                      className="form-control"
                      placeholder="Enter Description"
                      maxLength="500"
                      name="description"
                      value={description}
                      onChange={handleDescriptionChange}
                    />
                  </div>
                </div>
              </div>
              {chunkArray(
                Object.keys(toggles).filter((toggleKey) => !["displayingrid", "isTransactionMethodKey", "isTransactionMethodValue", "isTransactionChannel", "IsMerchant", "isTransactionTime", "isSourceName", "isSourceType", "isBankTransId", "isFormView"].includes(toggleKey)),
                4
              ).map((chunk, index) => (
                <div key={index} className="row">
                  {chunk.map((toggleKey) => (
                    <div key={toggleKey} className="col-sm-12 col-md-3 mt-3">
                      <div className="person" style={{ display: "flex", alignItems: "center" }}>
                        <p className="voucher" style={{ display: "flex", width: "100%", marginBottom: "0", color: "black" }}>
                          {toggleKey.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())}
                        </p>
                        <div>
                          <label className="toggle toggle_small">
                            <input
                              type="checkbox"
                              checked={toggles[toggleKey]}
                              onChange={() => handleToggleChange(toggleKey)}
                            />
                            <span className="slider"></span>
                            <span className="labels" data-on="true" data-off="false"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
              <div className="row mt-2">
                <div className="col-sm-12">
                  <div className="button-section justify-end">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </ValidatorForm>
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
                    <Button onClick={props.close}>Close</Button>
                </Modal.Footer> */}
      </Modal >
    </>
  );
};

export default CustomerViewMOdal;
